import { useTranslation } from 'react-i18next';
import { NavigateFunction } from 'react-router-dom';
import { QueryClient } from '@tanstack/react-query';
import usePickupData from './usePickupData';
import { getColumns } from '@/pages/pickups/list.tsx';
import { useOpenEntityTicketModal } from './useOpenEntityTicketModal';
import { TicketEntityIDFieldEnum } from '@/constants';
import usePermission from './usePermission';

/**
 * Custom hook to manage Pickup tab data and columns
 * @param current Current page number
 * @param pageSize Size of each page
 * @param enabled Whether the tab is currently active
 * @param queryClient Query client instance
 * @param search Optional search query string
 */
const usePickupTab = (
  current: number,
  pageSize: number,
  enabled = true,
  queryClient: QueryClient,
  search?: string,
) => {
  const { t } = useTranslation();
  const { hasPermission } = usePermission();

  const { dataPickup, totals, isFetching, refetch } = usePickupData(
    current,
    pageSize,
    enabled,
    search,
  );
  const { openEntityTicketModal } = useOpenEntityTicketModal(TicketEntityIDFieldEnum.PICKUP);

  // Get columns for Pickup tab
  const columns = getColumns(t, queryClient, openEntityTicketModal, hasPermission);

  return {
    data: dataPickup,
    totals,
    isFetching,
    columns,
    refetch,
  };
};

export default usePickupTab;
